import { render, staticRenderFns } from "./SelectDurationUnit.vue?vue&type=template&id=2acfb5ec&"
import script from "./SelectDurationUnit.vue?vue&type=script&lang=ts&"
export * from "./SelectDurationUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports